<template>
  <div>
    <div class="box">
      <div class="box-method">
        <h6>{{ options.label !== undefined ? options.label : 'VALOR DA COMPRA' }}</h6>
        <v-form ref="methodPaymentPrice" id="methodPaymentPrice">
          <v-text-field
              v-if="options.price_disabled"
              class="input-money"
              single-line
              v-bind:value="payment.price"
              required
              disabled
          ></v-text-field>
          <v-text-field
              v-else
              class="input-money"
              single-line
              v-money="money"
              v-model="payment.price"
              :rules="priceRule"
              required
          ></v-text-field>
        </v-form>
        <payment-form-list
            :payment-forms="paymentForms"
            @onPaymentForm="onPaymentFormChange"
            :selectedPaymentFormId="selectedPaymentFormId"
        />
      </div>

      <div class="content-method" v-if="showSavedCards && savedCards.length > 0 && !showCardForm">
        <saved-cards-list
            :cards="savedCards"
            :payment-form-id="selectedPaymentFormId"
            @card-selected="handleCardSelected"
            @add-new-card="showCardForm = true"
            @delete-card="handleDeleteCard"
        />
      </div>

      <div class="content-method" v-show="(selectedPaymentFormId === 2 || selectedPaymentFormId === 3) && (showCardForm || savedCards.length === 0)">
        <div class="form-header">
          <h6>INFORMAÇÕES DO {{ selectedPaymentForm.name }}</h6>
          <v-btn
              v-if="savedCards.length > 0"
              text
              small
              color="primary"
              @click="showCardForm = false"
          >
            <v-icon left small>mdi-arrow-left</v-icon>
            Voltar aos cartões salvos
          </v-btn>
        </div>

        <v-form ref="methodPaymentCards" id="methodPaymentCards">
          <v-row>
            <v-col cols="12" class="mb-0 pb-0">
              <v-select
                  v-if="selectedPaymentFormId === 3"
                  :items="banks"
                  class="select"
                  placeholder="Selecione um banco"
                  :rules="rules.bank"
                  solo
                  required
              />
              <v-text-field
                  solo
                  class="input"
                  v-model="payment.card.number"
                  label="Número do cartão"
                  :rules="rules.number_card"
                  v-mask="selectedPaymentFormId === 3 ? ['####.####.####.####','######.####.#####.####'] : ['####.####.####.####']"
                  required
              >
              </v-text-field>
              <v-text-field
                  solo
                  class="input"
                  v-model="payment.card.card_holder"
                  label="Nome impresso no cartão"
                  :rules="rules.name"
                  required
              >
              </v-text-field>
            </v-col>
            <v-col v-if="cardValidityMask4" class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  class="input"
                  v-model="payment.card.valid_month"
                  label="Data de validade (MM/YY)"
                  :rules="rules.valid"
                  v-mask="['##/##']"
                  required
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <i v-on="on" class="far fa-question-circle"></i>
                    </template>
                    <span class="d-block my-2">MÊS e ANO de validade impressos no cartão (ex. 08/32)</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col v-else class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  class="input"
                  v-model="payment.card.valid_month"
                  label="Data de validade (MM/YYYY)"
                  :rules="rules.valid"
                  v-mask="['##/####']"
                  required
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <i v-on="on" class="far fa-question-circle"></i>
                    </template>
                    <span class="d-block my-2">MÊS e ANO de validade impressos no cartão (ex. 08/2032)</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  class="input"
                  v-model="payment.card.ccv"
                  label="Código de segurança (CCV)"
                  :rules="rules.ccv"
                  v-mask="['###', '####']"
                  required
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <i v-on="on" class="far fa-question-circle"></i>
                    </template>
                    <span class="d-block my-2">Três dígitos localizado no verso do cartão</span>
                    <div style="text-align: center;">
                      <img src="@/assets/imgs/card-ccv.png" alt="card-back">
                    </div>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" v-if="shouldSaveCard">
              <div class="save-card-container">
                <v-switch
                    v-model="payment.card.save_card"
                    label="Salvar Cartão?"
                    color="primary"
                    @change="handleSaveCardToggle"
                ></v-switch>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <div class="content-method" v-if="selectedPaymentFormId === 4">
        <h6>MEUS CRÉDITOS</h6>
        <div>
          <select-wallet :shares="false" v-on:update:wallet="payment.wallet = $event"></select-wallet>
        </div>
      </div>

      <div class="content-method" v-if="selectedPaymentFormId === 5">
        <h6>INFORMAÇÕES DO BOLETO DE COBRANÇA</h6>
        <v-form ref="methodPaymentBoleto" id="methodPaymentBoleto">
          <v-row>
            <v-col cols="12" md="6" class="mb-0 pb-0">
              <v-text-field
                  solo
                  v-model="payment.boleto.cep"
                  :rules="rules.cep"
                  v-mask="['#####-###']"
                  @blur="searchCep"
                  required
                  label="CEP"
              >
              </v-text-field>
            </v-col>
            <v-col class="mb-0 pb-0" cols="12" md="6">
              <v-text-field
                  solo
                  v-model="payment.boleto.address"
                  :rules="rules.address"
                  required
                  label="Endereço"
              >
              </v-text-field>
            </v-col>
            <v-col class="mb-0 pb-0" cols="12" md="6">
              <v-text-field
                  solo
                  v-model="payment.boleto.complement"
                  label="Complemento"
              >
              </v-text-field>
            </v-col>
            <v-col class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  v-model="payment.boleto.number"
                  :rules="rules.number"
                  required
                  v-mask="['#####']"
                  label="Nº"
              >
              </v-text-field>
            </v-col>
            <v-col class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  v-model="payment.boleto.district"
                  :rules="rules.district"
                  required
                  label="Bairro"
              >
              </v-text-field>
            </v-col>
            <v-col class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  v-model="payment.boleto.city"
                  :rules="rules.city"
                  required
                  label="Cidade"
              >
              </v-text-field>
            </v-col>
            <v-col class="pt-0 mt-0" cols="12" md="6">
              <v-text-field
                  solo
                  v-model="payment.boleto.uf"
                  :rules="rules.uf"
                  required
                  @keyup="payment.boleto.uf = payment.boleto.uf.toUpperCase()"
                  v-mask="['SS']"
                  label="Estado"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>

    <card-save-terms-dialog
        v-model="showTermsDialog"
        @accept="handleTermsAccepted"
        @reject="handleTermsRejected"
        @error="handleTermsError"
    />

    <iframe v-if="fingerPrint" style="width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;"
            :src="'https://h.online-metrix.net/fp/tags?org_id=k8vif92e&session_id=redeceler_dm'+fingerPrint"></iframe>
  </div>
</template>

<script>
import Vue from 'vue';
import ViaCep from 'vue-viacep';
import { VMoney } from "v-money";
import SelectWallet from '@/components/SelectWallet.vue';
import PaymentFormList from "@/components/MethodPayment/PaymentFormList.vue";
import SavedCardsList from '@/components/CardsVault/SavedCardsList.vue';
import CardSaveTermsDialog from '@/components/CardsVault/CardSaveTermsDialog.vue';
import moment from "moment";
import axios from "axios";
import cardVaultService from "@/services/CardVaultService";

Vue.use(ViaCep);

export default {
  directives: { money: VMoney },
  name: "MethodPaymentV2",
  props: [
    'transactionType',
    'validPayment',
    'options'
  ],
  components: {
    PaymentFormList,
    SelectWallet,
    SavedCardsList,
    CardSaveTermsDialog
  },
  data() {
    return {
      loading: false,
      paymentForms: [],
      selectedPaymentFormId: null,
      userAddress: null,
      fingerPrint: undefined,
      savedCards: [],
      showCardForm: false,
      showCVVDialog: false,
      showTermsDialog: false,
      selectedSavedCard: null,
      termsAccepted: false,
      shouldSaveCard: false,
      payment: {
        wallet: {},
        price: 0,
        method: {
          id: 2,
          name: 'CARTÃO DE CRÉDITO'
        },
        boleto: {
          cep: '',
          address: '',
          district: '',
          uf: '',
          city: '',
          number: '',
          complement: '',
        },
        card: {
          card_holder: '',
          ccv: '',
          number: '',
          type: null,
          valid_month: '',
          valid_year: '',
          save_card: false,
          terms_accepted: false,
        }
      },
      methods: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
      },
      rules: {
        name: [
          value => (value || '').length > 0 || 'O nome impresso no cartão é obrigatório',
          value => this.validName(value) || 'Digite o nome completo'
        ],
        number_card: [
          value => (value || '').length > 0 || 'O número do cartão é obrigatório',
          value => (value.length === 19 || value.length === 22) || 'Digite o número do cartão',
        ],
        valid: [
          value => (value || '').length > 0 || 'O mês e ano de validade do cartão são obrigatórios',
          value => this.validCardValid(value) || 'Digite o mês e ano de validade impressos no cartão',
        ],
        ccv: [
          value => (value || '').length > 0 || 'O código de segurança do cartão é obrigatório',
          value => value.length >= 3 || 'Digite o código de segurança do cartão',
        ],
        cep: [
          value => (value || '').length > 0 || 'O campo cep é obrigatório',
          value => (value || '').length > 8 || 'Digite o cep',
        ],
        address: [
          value => (value || '').length > 0 || 'O campo endereço é obrigatório',
          value => (value || '').length > 3 || 'Digite o endereço',
        ],
        number: [value => (value || '').length > 0 || 'O campo número é obrigatório',],
        district: [value => (value || '').length > 0 || 'O campo bairro é obrigatório',],
        uf: [value => (value || '').length > 1 || 'O campo estado é obrigatório',],
        city: [value => (value || '').length > 0 || 'O campo cidade é obrigatório',],
        bank: [value => (value || '').length > 0 || 'É obrigatório selecionar um banco']
      },
    }
  },
  async mounted() {
    const [user, paymentFormList] = await Promise.all([
      this.getRemoteUser(),
      this.getPaymentFormList()
    ]);

    if (user.address) {
      this.loadInitialAddress(user.address);
    }

    this.handleConfig(user.config, paymentFormList);
  },
  computed: {
    showSavedCards() {
      return (this.selectedPaymentFormId === 2 || this.selectedPaymentFormId === 3) && !this.loading;
    },
    allowedPaymentForms() {
      return [2, 3, 4, 5, 11];
    },
    selectedPaymentForm() {
      if (this.selectedPaymentFormId) {
        return this.paymentForms.find(el => el.payment_form_id === this.selectedPaymentFormId);
      }
      return {};
    },
    priceRule() {
      return [value => this.validPrice(value, this.selectedPaymentForm)];
    },
    cardValidityMask4() {
      return process.env.VUE_APP_CARD_VALIDATE_MASK_4;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    },
    banks() {
      return ['Banco do Brasil', 'Bradesco', 'Caixa', 'Santander', 'Itaú'];
    }
  },
  methods: {
    async loadSavedCards() {
      if (this.selectedPaymentFormId !== 2 && this.selectedPaymentFormId !== 3) {
        return;
      }

      try {
        this.loading = true;
        const response = await cardVaultService.getCards(this.selectedPaymentFormId);
        this.savedCards = response.data || [];
        this.showCardForm = this.savedCards.length === 0;
      } catch (error) {
        this.savedCards = [];
        this.showCardForm = true;
      } finally {
        this.loading = false;
      }
    },
    handleCardSelected(card) {
      this.selectedSavedCard = card;
      this.showCVVDialog = true;
    },
    handleCVVConfirmed(cvv) {
      const cardData = {
        displayNumber: this.formatCardNumber(this.selectedSavedCard.card.number),
        number: this.selectedSavedCard.card.number,
        ccv: cvv,
        valid_month: this.selectedSavedCard.card.valid_month,
        valid_year: this.selectedSavedCard.card.valid_year,
        card_holder: this.selectedSavedCard.card.card_holder,
        type: this.selectedPaymentFormId,
        save_card: false,
        brand: this.selectedSavedCard.card.brand
      };

      this.payment.card = cardData;
      this.$emit('update:validated', {
        ...this.payment,
        paymentForm: this.selectedPaymentForm,
      });
    },
    formatCardNumber(number) {
      const last4 = number.slice(number.length - 4);
      const blur = '*'.repeat(number.length - 4);
      return `${blur} ${last4}`;
    },
    async handleDeleteCard(cardId) {
      try {
        this.loading = true;
        await cardVaultService.deleteCard(cardId);
        this.savedCards = this.savedCards.filter(card => card.id !== cardId);

        this.$emit('loading', false);
        this.showSnackbar('Cartão excluído com sucesso!', 'success');

        if (this.savedCards.length === 0) {
          this.showCardForm = true;
        }
      } catch (error) {
        this.showSnackbar('Erro ao excluir cartão. Tente novamente.', 'error');
      } finally {
        this.loading = false;
      }
    },
    handleSaveCardToggle() {
      if (this.payment.card.save_card && !this.termsAccepted) {
        this.checkTermsAvailability();
      }
    },
    async checkTermsAvailability() {
      try {
        const response = await cardVaultService.getCardSaveTerms();

        if (response && response.data && response.data.length > 0 && response.data[0].content) {
          this.showTermsDialog = true;
        } else {
          this.termsAccepted = true;
          this.payment.card.terms_accepted = true;
        }
      } catch (error) {
        this.termsAccepted = true;
        this.payment.card.terms_accepted = true;
      }
    },
    handleTermsAccepted() {
      this.termsAccepted = true;
      this.payment.card.terms_accepted = true;
      this.payment.card.save_card = true;
    },
    handleTermsRejected() {
      this.payment.card.save_card = false;
      this.payment.card.terms_accepted = false;
    },
    handleTermsError(errorMsg) {
      this.showSnackbar(errorMsg, 'error');
      this.payment.card.save_card = false;
    },
    showSnackbar(message, type) {
      this.$emit('snackbar', { message, type });
    },
    searchCep() {
      if (this.payment.boleto.cep !== '' && this.payment.boleto.cep !== null && this.payment.boleto.cep.length === 9) {
        this.$viaCep.buscarCep(this.payment.boleto.cep).then((obj) => {
          this.payment.boleto.address = obj.logradouro;
          this.payment.boleto.city = obj.localidade;
          this.payment.boleto.district = obj.bairro;
          this.payment.boleto.uf = obj.uf;
        });
      }
    },
    resetFormValidation() {
      if (this.$refs.methodPaymentCards !== undefined) {
        this.$refs.methodPaymentCards.reset();
        this.$refs.methodPaymentCards.resetValidation();
      }
      if (this.$refs.methodPaymentBoleto !== undefined) {
        this.$refs.methodPaymentBoleto.reset();
        this.$refs.methodPaymentBoleto.resetValidation();
      }
    },
    validName(value) {
      const pattern = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ ]+$/;
      const split = value.split(' ');
      const key = split.length;
      const secondNameValid = split[key - 1];
      return value.includes(' ') && value.length > 6 && (secondNameValid && secondNameValid.length > 1) && pattern.test(value);
    },
    validPrice(value, paymentForm) {
      paymentForm = paymentForm || {};
      const minAmount = paymentForm.min_amount || 1;
      const maxAmount = paymentForm.max_amount || 50000;

      if (value !== 0 && value !== undefined) {
        const price = parseInt(value.split(' ')[1].split('.').join('').split(',').join(''), 10);

        if (price >= minAmount && price <= maxAmount) {
          return true;
        }
      }
      return `Mínimo R$ ${this.formatMoney(minAmount)} / Máximo R$ ${this.formatMoney(maxAmount)}`;
    },
    validCardValid(value) {
      const date = value.split('/');

      if (this.cardValidityMask4) {
        if (value.length === 5) {
          return !(date[0] < '01' || date[0] > '12' || (date[0] < moment().format('MM') && date[1] === moment().format('YY')) || date[1] < moment().format('YY'));
        } else {
          return false;
        }
      } else {
        if (value.length === 7) {
          return !(date[0] < '01' || date[0] > '12' || (date[0] < moment().format('MM') && date[1] === moment().format('YYYY')) || date[1] < moment().format('YYYY'));
        } else {
          return false;
        }
      }
    },
    validatePaymentForm() {
      if ([2, 3].includes(this.selectedPaymentFormId) && this.showCardForm) {
        return this.$refs.methodPaymentCards.validate() !== false;
      }
      if (5 === this.selectedPaymentFormId) {
        return this.$refs.methodPaymentBoleto.validate() !== false;
      }
      return true;
    },
    async validateForm() {
      if (!this.$refs.methodPaymentPrice) {
        return;
      }

      if (this.$refs.methodPaymentPrice.validate() !== false) {
        if (!this.validatePaymentForm()) {
          return;
        }

        if ([2, 3].includes(this.selectedPaymentFormId) && this.showCardForm) {
          this.$emit('loading', true);
          this.fingerPrint = this.uniqueId();
          await new Promise(resolve => setTimeout(() => resolve(), 3000));
          this.payment.card.fingerPrint = this.fingerPrint;
          this.$emit('loading', false);
        }

        this.$emit('update:validated', {
          ...this.payment,
          paymentForm: this.selectedPaymentForm,
        });
      }
    },
    async onPaymentFormChange(paymentForm) {
      this.selectedPaymentFormId = paymentForm.payment_form_id;
      this.$refs.methodPaymentPrice.validate();

      await this.loadSavedCards();
      this.checkSaveCardConfig();
    },
    checkSaveCardConfig() {
      const config = this.paymentForms.find(el => el.payment_form_id === this.selectedPaymentFormId);
      this.shouldSaveCard = config && config.save ? config.save : false;
    },
    async getRemoteUser() {
      const { data } = await axios.get('/api/user');
      return data;
    },
    async getPaymentFormList() {
      const { data: { data } } = await axios.get('/api/transaction/payment/forms');
      return data;
    },
    loadInitialAddress(address) {
      if (address) {
        const parsedAddress = JSON.parse(address);
        const [street, street_number, street_complement] = parsedAddress.address.split(',');
        this.userAddress = {
          address: street,
          cep: parsedAddress.cep,
          city: parsedAddress.city,
          complement: street_complement ? street_complement : '',
          district: parsedAddress.district,
          number: street_number,
          uf: parsedAddress.uf
        };
        this.setAddress(this.userAddress);
      }
    },
    setAddress(address) {
      this.payment.boleto = { ...address };
    },
    handleConfig(config, paymentFormList) {
      if (config.paymentForm) {
        this.handlePaymentFormConfig(config.paymentForm, paymentFormList);
      }
    },
    handlePaymentFormConfig(forms, paymentFormList) {
      this.paymentForms = forms.filter(value => {
        const hasThisTransaction = value.allowed_transactions.find(
            value1 => value1.type === this.transactionType,
        );
        return hasThisTransaction && this.allowedPaymentForms.includes(value.payment_form_id);
      }).map(el => ({
        name: paymentFormList.find(dbPaymentForm => dbPaymentForm.id === el.payment_form_id).name,
        payment_form_id: el.payment_form_id,
        save: el.save !== undefined ? el.save : false,
        min_amount: el.allowed_transactions.find(
            value1 => value1.type === this.transactionType,
        ).min_amount
      }));

      if (this.paymentForms.length > 0) {
        this.selectedPaymentFormId = this.paymentForms[0].payment_form_id;
        this.loadSavedCards();
        this.checkSaveCardConfig();
      }
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.price) {
          this.payment.price = 'R$ ' + this.formatMoney(newVal.price);
        }
      },
    },
    validPayment: {
      deep: true,
      immediate: true,
      handler() {
        if (this.validPayment !== null) {
          this.validateForm();
        }
      }
    }
  },
}
</script>

<style scoped>
.box {
  display: flex;
  flex-wrap: wrap;
}

.box-method, .content-method {
  padding: 15px;
}

.box-method {
  width: 300px;
  background: transparent;
  border-radius: 4px;
  display: block;
}

h6 {
  font-size: 12px;
  font-family: Roboto-Light;
  color: #a8a8a8;
  margin: 0;
}

.box-method .input-money, .input-money >>> .v-text-field__slot input {
  font-size: 32px;
  font-family: Roboto-Black;
  color: #000 !important;
  margin-top: 0;
}

.input >>> .v-text-field__slot input {
  font-size: 18px;
  font-family: Roboto-Black;
  color: #000 !important;
  margin-top: 0;
}

.select >>> .v-select__selection--comma {
  font-size: 18px;
  font-family: Roboto-Black;
  color: #000 !important;
}

.content-method {
  flex: 1;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.save-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

@media only screen and (max-width: 500px) {
  .box-method, .content-method {
    padding: 5px;
  }

  .form-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
